<mat-radio-group
    [value]="selectedValue"
    [ngClass]="computedGroupClasses"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledBy"
    [attr.name]="name || uniqueGroupName"
    [disabled]="disabled">
    <!-- Manual MDC DOM simulation to bypass Angular Material's dynamic inline-styles -->
    <div
        *ngFor="let option of radioOptions; let i = index"
        class="mat-mdc-radio-button inline-block mr-4"
        [ngClass]="computedButtonClasses"
        [class.mat-mdc-radio-checked]="selectedValue === (emitEvent ? option : option.value !== undefined ? option.value : option)"
        [class.mdc-radio--disabled]="disabled"
        [attr.title]="
            option.title || option.displayName || option.name || option.label || (option.value !== undefined ? option.value : option)
        ">
        <div
            class="mdc-form-field"
            (click)="
                !disabled && onSelectionChange(emitEvent ? option : option.value !== undefined ? option.value : option);
                $event.preventDefault()
            ">
            <div class="mdc-radio" [class.mdc-radio--disabled]="disabled">
                <input
                    type="radio"
                    class="mdc-radio__native-control"
                    [id]="(name || uniqueGroupName) + '_' + i + '_' + (option.id || i)"
                    [name]="name || uniqueGroupName"
                    [disabled]="disabled"
                    [checked]="selectedValue === (emitEvent ? option : option.value !== undefined ? option.value : option)"
                    (change)="onSelectionChange(emitEvent ? option : option.value !== undefined ? option.value : option)" />
                <div class="mdc-radio__background">
                    <div class="mdc-radio__outer-circle"></div>
                    <div class="mdc-radio__inner-circle"></div>
                </div>
            </div>

            <label class="mdc-label" [attr.for]="(name || uniqueGroupName) + '_' + i + '_' + (option.id || i)">
                <span
                    [textContent]="
                        option.displayName || option.name || option.label || (option.value !== undefined ? option.value : option)
                    "></span>
            </label>
        </div>
    </div>
</mat-radio-group>
